import { render, staticRenderFns } from "./ComplaintForm.vue?vue&type=template&id=7716ce87"
import script from "./ComplaintForm.vue?vue&type=script&lang=js"
export * from "./ComplaintForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports